import _ from 'lodash';
import React, { useState, useEffect, useRef, memo } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Col,
  Row,
  Container,
  Spinner,
  Label,
  Input,
  Tooltip,
} from 'reactstrap';
import { BrowserView, MobileView, isMobile, isTablet } from 'react-device-detect';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Block from '../common/Display/Block';
import ReportElement from './ReportElement';
import Alerts from './Alerts';
import Totals from './Totals';
import ImageGalery from './ImageGallery';
import Translate, { t, numStr } from '../common/Translate';
import getValue from '../../services/Form/getValue';
import getFormLocal from '../../services/Form/getFormLocal';
import updateFormStatus from '../../services/Form/updateFormStatus';
import {
  STATUS,
  LOCALSTATUS,
  DISPLAY_REFERENTIALS,
  ROLE_ID,
  HT_REFERENTIALS,
  TTC_REFERENTIALS,
  dmsStatusList,
  RECORD_STATUS,
  pdfCostUrl,
} from '../../config';
import mapStateToProps from '../../Store/mapping/record/mapStateToProps';
import mapDispatchToProps from '../../Store/mapping/record/mapDispatchToProps';
import { hideTabs } from '../../Utils/hideTabs';
import { Auth, formManager, recordActions, report } from '../../config/configuration/react';
import { formatEntryStocksDays } from '../../Store/helpers/pricing';
import { DefaultAlertModal } from '../common/Modal/DefaultAlertModal';
import { currencySign } from '../../Utils/currencySign';
import { Calculator } from '../../Store/helpers/Calculator';
import saveValue from '../../services/Form/saveValue';
import { Record } from '../../config/Record/RecordEntity';

const { completed, submitted, report_available, appraisal_stopped, in_progress } = STATUS;
const { not_updated, updated, tmp_form } = LOCALSTATUS;
const { outdated, expertise_finished, expertise_started } = RECORD_STATUS;
const statusReport = [completed, submitted, report_available, appraisal_stopped];
const localStatusReport = [not_updated, updated, tmp_form];

const pathToReport = 'inspection.report';

const ReportList = (props) => {
  const { location, match } = props;
  let queries;
  if (location.state !== undefined && 'queries' in location.state) {
    queries = location.state.queries;
  }
  const { formId } = match.params;
  const dispatch = useDispatch();
  const [referential, setReferential] = useState('');
  const [referentialToDisplay, setReferentialToDisplay] = useState([]);
  const [data, setData] = useState({});
  const [isSubmited, setIsSubmited] = useState(true);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const blockNoTotals = [];
  const blockWithTotals = [];
  let alerts = {};
  let totals = {};
  const vehiclePictures = [];
  let vehicleTitle = ['', ''];
  const titlesNoTotals = [];
  const titlesWithTotals = [];
  const [activeSection, setActiveSection] = useState('file');
  const recordId = useSelector((state) => state.reduxRecords?.currentRecord);
  const recordData = useSelector((state) => state.reduxRecords.data[recordId]);
  const record = useSelector((state) => state.reduxRecords.data[recordId]?.record) || {};
  const recordEntity = new Record(recordData);
  const recordKey = useSelector((state) => state.reduxRecords.data[recordId]?.record?.recordKey);
  const pdfLanguage = useSelector((state) => state.reduxRecords.data[recordId]?.record?.language)?.toLowerCase();
  const countryLanguage = Auth.country()?.toLowerCase();
  const sourceInfos = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos);
  const source = sourceInfos?.source;
  const destinations = sourceInfos?.destinations;
  const recordTypeId = useSelector((state) => state.reduxRecords?.data[recordId]?.record?.recordTypeId);
  const configType = useSelector((state) => state.reduxRecords.data[recordId])?.record?.configType;
  const entryStockOptions = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption;
  const supervisorEntryStock = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.entryStockValue);
  let supervisorEntryDate = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.entryStockDate?.date);
  const refHexa = useSelector((state) => state.reduxRecords.data[recordId]?.record?.refHexaId);
  supervisorEntryDate = supervisorEntryDate && moment(supervisorEntryDate).format('DD/MM/YYYY');
  if (supervisorEntryDate) {
    entryStockOptions.forEach((i) => {
      if (moment(i[supervisorEntryStock]).format('DD/MM/YYYY') === supervisorEntryDate) supervisorEntryDate = false;
    });
  }
  const [entryStockValue, setEntryStockValue] = useState(supervisorEntryStock);
  const [entryStockDate, setEntryStockDate] = useState(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const countryId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.countryId);
  const country = useSelector((state) => state.reduxRecords.data[recordId]?.record?.country);
  const expertiseEndDate = useSelector((state) => state.reduxRecords.data[recordId]?.expertise?.expertiseEndedAt?.date);
  const calculator = new Calculator({ country });
  const isDE = countryId === 2;
  const [symbol, setSymbol] = useState();
  const isMounted = useRef(false);
  const recordStatus = useSelector((state) => state.reduxRecords.data[recordId])?.record?.statusId;
  const nrmStatusId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.nrmStatusId || 0;
  const [status, setStatus] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const dms = useSelector((state) => state.reduxRecords.data[recordId]?.destinations);
  const concessionDms = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.destinations);
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const [dmsLoading, setDmsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [disable, setDisable] = useState(false);
  const dmsStatus = dms && dmsStatusList[dms?.[1]?.status];
  const dmsStatusId = dms && dms?.[1]?.status;
  const [errorDms, setErrorDms] = useState();
  const [showCta, setShowCta] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [body, setBody] = useState(t('tittleAbandonAppraisalPopUp'));
  const [comment, setComment] = useState('');
  const taxExcludedVatRef = useRef(calculator.getTaxExcludedVat());
  const toggleModel = () => {
    setIsOpen((prevState) => !prevState);
    setComment('');
  };

  const checkDms = (destinationLists) => {
    Object.values(destinationLists).forEach((destination) => {
      if ([2, 3].includes(destination.status)) return setDisable(true);
      return null;
    });
  };

  useEffect(() => {
    if (concessionDms && !isMounted.current) {
      const bee2LinkDms = concessionDms.filter((cd) => cd.label === 'B2eelink');
      const sourceDms = destinations.filter((cd) => cd.label === 'B2eelink');
      if (bee2LinkDms.length > 0 && sourceDms.length > 0) {
        if (bee2LinkDms[0].dealerCode && bee2LinkDms[0].dealerCode !== '')
          if (sourceDms[0].recordType === recordTypeId) return setShowCta(bee2LinkDms[0].displayManualSendCta);
      }
    }
    return () => {
      isMounted.current = true;
    };
  }, []);

  useEffect(() => {
    if (dms) checkDms(dms);
  }, [dms]);

  useEffect(() => {
    setEntryStockValue(supervisorEntryStock);
  }, [supervisorEntryStock]);

  useEffect(() => {
    if (supervisorEntryDate) setEntryStockValue(supervisorEntryDate && 'selected');
  }, [supervisorEntryDate]);

  useEffect(() => {
    if (entryStockOptions && (!recordEntity.isHBS() || (recordEntity.isHBS() && !supervisorEntryDate))) {
      entryStockOptions.forEach((i) => {
        if (_.get(i, entryStockValue)) return setEntryStockDate(_.get(i, entryStockValue));
        return false;
      });
    } else if (recordEntity.isHBS() && supervisorEntryDate)
      setEntryStockDate(moment(supervisorEntryDate, 'DD/MM/YYYY').format('YYYY/MM/DD'));
  }, [entryStockValue]);

  const openInfoBull = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const getContent = async (form) => {
    let content = {};
    if ([10, 12, 13].includes(originId)) {
      content = await report.processReport(form, 'reportList', sourceInfos, {
        recordId,
        countryId: record?.countryId,
      });
    } else {
      content = await report.processReport(form, 'reportList', sourceInfos);
    }
    setData(content.display);
  };

  const checkStatus = async () => {
    setLoading(true);
    const fileStatus = await getValue(formId, 'status');
    setStatus(fileStatus[0]);
    if (!statusReport.includes(fileStatus[0])) setRedirect(`/forms/${formId}`);
    const form = await getFormLocal(formId);
    if ([submitted].includes(fileStatus[0])) {
      const reportFile = _.get(form, pathToReport, null);
      taxExcludedVatRef.current = _.get(form, `inspection.vatExcluded`, 1);
      if (reportFile !== null && typeof reportFile === 'object') {
        setData(reportFile);
        setLoading(false);
        return;
      }
    }
    await saveValue(formId, `inspection.vatExcluded`, calculator.getTaxExcludedVat());
    await getContent(form);
    setLoading(false);
  };

  const checkLocalStatus = async () => {
    const fileLocalstatus = await getValue(formId, 'localStatus');
    const fileStatus = await getValue(formId, 'status');
    if (localStatusReport.includes(fileLocalstatus[0]) && recordStatus === expertise_started) setIsSubmited(false);
    if (recordStatus !== outdated && fileStatus[0] === appraisal_stopped) setIsSubmited(false);
  };

  /* const getFormConfigType = async () => {
    if (recordId === null) return;
    dispatch(recordActions.getConfigForm(recordId));
  };

  useEffect(() => {
    getFormConfigType();
  }, [recordId]); */

  useEffect(() => {
    checkStatus();
    checkLocalStatus();
    return () => {
      isMounted.current = true;
    };
  }, [formId]);

  useEffect(() => {
    if (TTC_REFERENTIALS.includes(referential) || referential.includes('external')) setSymbol('TTC');
    else if (HT_REFERENTIALS.includes(referential) || referential.includes('internal')) setSymbol('HT');
    else setSymbol(currencySign('', country));
  }, [referential]);

  const extractVehicleTitle = (value) => {
    vehicleTitle = [];
    const brandLabel = _.get(value, 'brandLabel[1]', '');
    const modelLabel = _.get(value, 'modelLabel[1]', '');
    const registration = isDE ? _.get(value, 'vin[1]', '') : _.get(value, 'registration[1]', '');
    let registrationDate = _.get(value, 'registrationDate[1]', '');
    const vehicule_test_mileage = _.get(value, 'vehicule_test_mileage[1]', '');
    const refHexaId = _.get(data, 'file.id[1]', '');
    if (registrationDate !== '') {
      try {
        registrationDate = moment(registrationDate).format('YYYY');
      } catch {
        // logError('warning', 'registration date format not as expected');
      }
    }
    vehicleTitle[0] = `${brandLabel} ${modelLabel} `;
    vehicleTitle[1] = `${numStr(vehicule_test_mileage)} km | ${registrationDate}`;
    if (registration !== '') vehicleTitle[1] += ` | ${registration}`;
    if (refHexaId !== '') vehicleTitle[1] += ` | ${refHexaId.toUpperCase()}`;
    return vehicleTitle;
  };

  const createPdf = async () => {
    setPdfLoading(true);
    const req = new Request(pdfCostUrl.url, {
      method: 'POST',
      body: JSON.stringify({
        selector: '#isLoading',
        url:
          countryLanguage === 'be'
            ? `${window.location.origin}/pdf/${recordKey}/cost/${referential}/${pdfLanguage}`
            : `${window.location.origin}/pdf/${recordKey}/cost/${referential}/${countryLanguage}`,
      }),
      headers: {
        'x-api-key': pdfCostUrl.key,
      },
    });
    let response = await fetch(req);
    response = await response.blob();
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `pdfCost-${refHexa}-${referential}.pdf`);
    document.body.appendChild(link);
    link.click();
    setPdfLoading(false);
    document.body.removeChild(link);
  };
  const getImportedExpertise = (value) => {
    if (![undefined, null].includes(value.imported?.[1])) return value.imported;
    const imported = _.get(data, 'admin.imported_expertise', null)?.[1];
    const truthyValues = ['true', 'yes', true];
    const falsyValues = ['false', 'no', false];
    if (truthyValues.includes(imported)) {
      return ['boolean', true];
    }
    if (falsyValues.includes(imported)) {
      return ['boolean', false];
    }
    return ['boolean', null];
  };

  let referentials = {};
  let card = '';
  let sectionTitles = '';
  let sectionContents = '';

  // Process the data for display
  Object.entries(data).forEach(([key, value]) => {
    const sectionValue = { ...value };
    if (key === 'vehicle') {
      vehicleTitle = extractVehicleTitle(value);
      sectionValue.imported = getImportedExpertise(value);
    }
    if (key === 'customer' || key === 'file') return;
    if (key === 'alerts') {
      alerts = value;
      return;
    }

    if (key === 'totals') {
      referentials = data.totals;
      totals = value;
      return;
    }
    if (isMobile) {
      card = (
        <div className="card-container" key={key}>
          <ReportElement
            country={country}
            section={key}
            content={sectionValue}
            referential={referential}
            formId={formId}
            isDE={isDE}
            symbol={symbol}
            refHexaId={refHexa}
            report={key === 'vehicle_pictures' && data}
          />
        </div>
      );

      if (value.totals === undefined) {
        blockNoTotals.push(card);
      } else {
        blockWithTotals.push(card);
      }
    } else {
      sectionTitles = (
        <div
          className={`tab-desktop clickable ${activeSection === key ? 'active' : ''}`}
          key={key}
          onClick={() => setActiveSection(key)}
          onKeyDown={() => {}}
          role="tab"
          tabIndex={0}
        >
          <Translate code={key} />
          {value.totals && (
            <div className="float-right font-weight-bold" data-testid={key}>
              {currencySign(value.totals[referential], country)}
              {` ${t(symbol)}`}
            </div>
          )}
        </div>
      );

      sectionContents = activeSection === key && (
        <React.Fragment key={key}>
          <h2>
            <Translate code={key} />
            <div className="float-right font-weight-bold">
              {value.totals && currencySign(value.totals[referential], country)}
              {value.totals && ` ${t(symbol)}`}
            </div>
          </h2>
          <ReportElement
            country={country}
            section={key}
            content={sectionValue}
            referential={referential}
            formId={formId}
            configType={['text', configType]}
            isDE={isDE}
            symbol={symbol}
            refHexaId={refHexa}
            expertiseEndDate={expertiseEndDate}
            report={key === 'vehicle_pictures' && data}
          />
        </React.Fragment>
      );

      if (value.totals === undefined) {
        titlesNoTotals.push(sectionTitles);
        blockNoTotals.push(sectionContents);
      } else {
        titlesWithTotals.push(sectionTitles);
        blockWithTotals.push(sectionContents);
      }
    }
  });

  // based on configuration, users cannot access any referentials
  const getSourceReferentials = (defaultReferentials) => {
    const roleId = Auth.roleId();
    const role = _.get(ROLE_ID, roleId);
    return _.get(DISPLAY_REFERENTIALS, `${source}.${role}`, defaultReferentials);
  };

  useEffect(() => {
    setActiveSection('vehicle_pictures');

    // We need to display specific refenentials based on role
    // it's only the display, referential to use for calculation is defined only by source
    const referentialsList = Object.keys(referentials);
    const sourceReferentials = getSourceReferentials(referentialsList);

    if (referential === '' && referentialsList.length > 0 && sourceReferentials) {
      // We try to let the user select only the referentials he's allowed to display
      let intersectionReferentials = _.intersection(sourceReferentials, referentialsList);

      // In cased there is a mistake in configuration or access, we display all referentials
      if (intersectionReferentials.length < 1) intersectionReferentials = referentialsList;

      setReferentialToDisplay(intersectionReferentials);
      setReferential(intersectionReferentials[0]);
    }
  }, [referentials]);

  const total = _.get(data, `totals.${referential}`, 0);

  // if button submit clicked, change the status and redirected
  const submitReport = async () => {
    setLoading(true);
    try {
      if (entryStockValue !== supervisorEntryStock)
        dispatch(recordActions.putSupervisorInfos(recordId, { entryStockValue, entryStockDate }));
      await formManager.submitForm(formId);
      setIsSubmited(true);
      setRedirect(`/files/${data.file.recordId[1]}`);
    } catch (e) {
      setError(e.message);
      setIsSubmited(false);
    } finally {
      if (!isMounted.current) {
        setLoading(false);
      }
    }
  };

  // if button edit clicked, change the localStatus and redirected
  const editReport = async (localstatus) => {
    setLoading(true);
    try {
      await updateFormStatus(formId, localstatus, 'status');
      setRedirect({
        pathname: `/forms/${formId}`,
        state: { queries },
      });
    } catch (e) {
      setError(e.message);
    } finally {
      if (!isMounted.current) setLoading(false);
    }
  };

  const postBee2LinkRequest = async () => {
    setDmsLoading(true);
    setLoadingMessage('infoSending');
    try {
      const res = await dispatch(recordActions.postBee2LinkRequest(recordId, { destinationId: 1 }));
      setDisable(res.status);
    } catch (e) {
      setErrorDms('error_check_configuration');
      setDisable(false);
    } finally {
      setDmsLoading(false);
      setLoadingMessage('');
    }
  };

  const handleClick = async () => {
    await dispatch(recordActions.updateStatus(recordId, 'outdated'));
    toggleModel();
    setRedirect(`/files/${data.file.recordId[1]}`);
  };

  const createVersion = async () => {
    await dispatch(recordActions.createInspectionVersion(recordId, { comment: comment || null }));
    await dispatch(recordActions.openRecord(recordId));
    await formManager.delete(formId);
    await formManager.saveFormInLocal(formId);
    if (!comment) {
      const redirectDelay = setTimeout(function () {
        setRedirect({
          pathname: `/forms/${formId}`,
          state: { queries },
        });
        window.clearTimeout(redirectDelay); // clear time out.
      }, 1500);
    } else {
      toggleModel();
      setRedirect({
        pathname: `/files/${recordId}`,
        state: { queries },
      });
    }
  };

  let alertCostumProps = {
    isOpen,
    toggle: toggleModel,
    body,
    handleCancel: toggleModel,
    handleValidate: handleClick,
    cancelBtn: 'cancel',
    validateBtn: 'confirm',
    centered: true,
    size: 'md',
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setComment(value);
  };

  if (body === 'buyerModify') {
    alertCostumProps = {
      ...alertCostumProps,
      body: (
        <>
          <Row>
            <Col>{t('comment')}</Col>
          </Row>
          <Row>
            <Col>
              <textarea rows={4} className="form-control rounded" id="comment" required onChange={handleOnChange} />
            </Col>
          </Row>
        </>
      ),
      disable: !comment,
      handleValidate: createVersion,
    };
  }

  const sendbuyerModify = async () => {
    setBody('buyerModify');
    toggleModel();
  };

  const disableCtaSubmit = _.get(data, `file.escape_question.${[1]}`, null);
  const reportTab = (
    <>
      <div className="report">
        <MobileView>
          <Row>
            <Col>
              <Alerts alerts={alerts} />
            </Col>
          </Row>
          <Row>{blockNoTotals}</Row>
          {vehiclePictures.length > 0 && (
            <Row>
              <Col>
                <ImageGalery images={vehiclePictures} formId={formId} />
              </Col>
            </Row>
          )}

          <div className="report-reference">
            <Container fluid>
              <Row>
                <Col>
                  <h6 className="mb-0">
                    <Translate code="refurbishment" />
                  </h6>
                </Col>
                <Col className="text-right" data-testid="refurbishment">
                  {currencySign(total, country)} <Translate code={symbol} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <DropdownButton
                    referential={referential}
                    referentials={referentials}
                    setReferential={setReferential}
                    total={total}
                    referentialToDisplay={referentialToDisplay}
                    source={source}
                  />
                </Col>
              </Row>
              {isSubmited && (
                <>
                  <Row className="text-right">
                    <Col>
                      {showCta && (
                        <button
                          type="button"
                          className={`btn mt-1 mr-n2 ${(disable && 'btn-4') || 'btn-3'}`}
                          id="b2Link"
                          onClick={postBee2LinkRequest}
                          disabled={disable}
                        >
                          {t('manualSendDmsCta')}
                        </button>
                      )}
                    </Col>
                  </Row>
                  <Row className="text-right">
                    <Col>
                      {errorDms && showCta && (
                        <p className="text-danger mr-n2">
                          <Translate code={errorDms} />
                        </p>
                      )}
                      {dmsStatus && showCta && (
                        <span
                          className={`mr-n2 ${((disable || dmsStatusId === 2) && 'text-success') || 'text-danger'}`}
                        >
                          {t(dmsStatus)}
                        </span>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </Container>
            {submitted === status && !Auth.roleViewerAccess() && (
              <Row className="text-right">
                <Col className="mr-2 mt-1">
                  <button type="button" block="true" className="btn btn-3" onClick={createPdf}>
                    <Translate code="downloadPdfCosts" />
                  </button>
                </Col>
              </Row>
            )}
            {submitted === status &&
              ((recordStatus === expertise_finished && nrmStatusId === 0) ||
                (recordStatus === expertise_finished && nrmStatusId > 0 && [1, 5, 10].includes(nrmStatusId))) &&
              Auth.role() !== 'buyer' &&
              !Auth.roleViewerAccess() && (
                <>
                  <Row className="text-right">
                    <Col className="mr-2 mt-1">
                      <button type="button" block="true" className="btn btn-1-outline" onClick={createVersion}>
                        <Translate code="versionModify" />
                      </button>
                    </Col>
                  </Row>
                  <Row className="text-right">
                    <Col className="mr-2 mt-1">
                      <button type="button" block="true" className="btn btn-1-outline" onClick={sendbuyerModify}>
                        <Translate code="sendbuyerModify" />
                      </button>
                    </Col>
                  </Row>
                </>
              )}
          </div>
          <Row>
            <Col>
              <Totals totals={totals} />
            </Col>
          </Row>

          <Row>{blockWithTotals}</Row>
        </MobileView>
        {!isTablet && (
          <BrowserView>
            <div className="report-desktop">
              <Row>
                <Col xs="5" md="4" lg="3">
                  <div className="report-tab-desktop">
                    <div className="no-totals">{titlesNoTotals}</div>
                    <div className="report-reference">
                      <Row>
                        <Col>
                          <Translate code="refurbishment" />
                        </Col>
                        <Col className="text-right" data-testid="refurbishment">
                          {currencySign(total, country)} <Translate code={symbol} />
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col>
                        <Totals totals={totals} />
                      </Col>
                    </Row>

                    <div className="with-totals">
                      {titlesWithTotals}
                      <div className="tab-desktop pb-5">
                        <DropdownButton
                          referential={referential}
                          referentials={referentials}
                          setReferential={setReferential}
                          total={total}
                          referentialToDisplay={referentialToDisplay}
                          source={source}
                        />
                      </div>
                    </div>
                    <Row className="desktop-footer-btn">
                      <Col>
                        <Label className="alternate" for="entryStockDays">
                          {t('entryStockDays')}
                          <>
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              size="1x"
                              id="entryStock"
                              className="info-icon ml-2"
                              onClick={openInfoBull}
                            />
                            <Tooltip
                              placement="bottom"
                              isOpen={tooltipOpen}
                              target="entryStock"
                              toggle={!isMobile && openInfoBull}
                            >
                              {originId === 12 || originId === 13 || originId === 14
                                ? t('entryStockDaysInfoNrmStandAlone')
                                : t('entryStockDaysInfo')}
                            </Tooltip>
                          </>
                        </Label>
                        <Input
                          type="select"
                          name="entryStockDays"
                          id="entryStockDays"
                          className="rounded"
                          onChange={(e) => setEntryStockValue(parseInt(e.target.value, 10))}
                          value={entryStockValue}
                          disabled={isSubmited}
                        >
                          {supervisorEntryDate && (
                            <option key="selected" value="selected">
                              {supervisorEntryDate}
                            </option>
                          )}
                          {entryStockOptions &&
                            formatEntryStocksDays(entryStockOptions).map((i, k) => (
                              <option key={i} value={k}>
                                {i}
                              </option>
                            ))}
                        </Input>
                      </Col>
                    </Row>
                    {(!isSubmited || status === 5) && (
                      <Row className="desktop-footer-btn">
                        <Col xs="12" className="mb-2">
                          <button
                            type="button"
                            block="true"
                            className="btn btn-block btn-3"
                            onClick={() => editReport(in_progress)}
                            data-cy="saveForm"
                          >
                            <Translate code="edit" />{' '}
                          </button>
                        </Col>
                        <Col xs="12" className="mb-2">
                          <button
                            type="button"
                            block="true"
                            className="btn btn-block btn-1"
                            onClick={submitReport}
                            data-cy="submitForm"
                            disabled={disableCtaSubmit}
                          >
                            <Translate code="send" />
                          </button>
                        </Col>
                        {disableCtaSubmit && (
                          <Col xs="12">
                            <button
                              type="button"
                              block="true"
                              className="btn btn-block btn-2"
                              onClick={toggleModel}
                              data-cy="submitForm"
                            >
                              <Translate code="abandonAppraisal" />
                            </button>
                          </Col>
                        )}
                      </Row>
                    )}
                    {submitted === status && !Auth.roleViewerAccess() && (
                      <Row className="desktop-footer-btn">
                        <Col xs="12">
                          <button type="button" block="true" className="btn btn-block btn-3" onClick={createPdf}>
                            <Translate code="downloadPdfCosts" />
                            {pdfLoading && <Spinner className="ml-1" color="primary" />}
                          </button>
                        </Col>
                      </Row>
                    )}
                    {submitted === status &&
                      ((recordStatus === expertise_finished && nrmStatusId === 0) ||
                        (recordStatus === expertise_finished && nrmStatusId > 0 && [1, 5, 10].includes(nrmStatusId))) &&
                      Auth.role() !== 'buyer' &&
                      !Auth.roleViewerAccess() && (
                        <Row className="desktop-footer-btn">
                          <Col xs="12">
                            <button
                              type="button"
                              block="true"
                              className="btn btn-block btn-1-outline mt-1"
                              onClick={createVersion}
                            >
                              <Translate code="versionModify" />
                            </button>
                          </Col>
                          <Col xs="12">
                            <button
                              type="button"
                              block="true"
                              className="btn btn-block btn-1-outline mt-1"
                              onClick={sendbuyerModify}
                            >
                              <Translate code="sendbuyerModify" />
                            </button>
                          </Col>
                        </Row>
                      )}
                    {isSubmited && (
                      <Row className="desktop-footer-btn">
                        <Col xs="12">
                          {showCta && (
                            <button
                              type="button"
                              className={`btn btn-block mt-3 ${(disable && 'btn-4') || 'btn-3'}`}
                              id="b2Link"
                              onClick={postBee2LinkRequest}
                              disabled={disable}
                            >
                              {t('manualSendDmsCta')}
                            </button>
                          )}
                          {errorDms && showCta && (
                            <p className="ml-2 text-danger">
                              <Translate code={errorDms} />
                            </p>
                          )}
                          {dmsStatus && showCta && (
                            <span className={`${((disable || dmsStatusId === 2) && 'text-success') || 'text-danger'}`}>
                              {t(dmsStatus)}
                            </span>
                          )}
                        </Col>
                      </Row>
                    )}
                  </div>
                </Col>
                {dmsLoading && (
                  <div className="loader-full-screen main">
                    <span className="dms-message">{t(loadingMessage)}</span>
                    <Spinner />
                  </div>
                )}
                <Col>
                  <Alerts alerts={alerts} />
                  <div className="no-totals">{blockNoTotals}</div>
                  <div className="with-totals">{blockWithTotals}</div>
                </Col>
              </Row>
            </div>
          </BrowserView>
        )}
        <DefaultAlertModal {...alertCostumProps} />
      </div>
    </>
  );

  let backRoute = '';
  if (queries) {
    if (typeof queries === 'string' && queries.startsWith('/files/')) backRoute = queries;
  } else {
    backRoute = '/forms';
  }
  return (
    <Block {...props} backRoute={backRoute} headerTitle={vehicleTitle[0]} subtitle={vehicleTitle[1]} showSubHeader>
      {redirect && <Redirect from="/" exact to={redirect} />}
      {loading && (
        <Col className="text-center">
          <Spinner color="primary" />
        </Col>
      )}
      {error && (
        <p className="text-center text-danger">
          <Translate code={error} />
        </p>
      )}
      {!loading && (
        <Container fluid className="report">
          <div className={`main-report ${!isSubmited && 'space-bottom'}`}>{reportTab}</div>
        </Container>
      )}
      <MobileView>
        {(!isSubmited || status === 5) && (
          <div className="report-footer">
            <Row>
              <Col>
                <button
                  type="button"
                  block
                  className="btn btn-block btn-3"
                  onClick={() => editReport(in_progress)}
                  data-cy="saveForm"
                >
                  <Translate code="edit" />{' '}
                </button>
              </Col>
              <Col>
                <button
                  type="button"
                  block
                  className="btn btn-block btn-1"
                  onClick={submitReport}
                  data-cy="submitForm"
                  disabled={disableCtaSubmit}
                >
                  <Translate code="send" />
                </button>
              </Col>
              {disableCtaSubmit && (
                <Col>
                  <button
                    type="button"
                    block="true"
                    className="btn btn-block btn-2"
                    onClick={toggleModel}
                    data-cy="submitForm"
                  >
                    <Translate code="abandonAppraisal" />
                  </button>
                </Col>
              )}
            </Row>
          </div>
        )}
      </MobileView>
      {/* <GetDamages data={data} referential={referential}/> */}
    </Block>
  );
};

ReportList.propTypes = {
  location: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);

const DropdownButton = memo((props) => {
  const { setReferential, referential, referentialToDisplay, source } = props;
  let { referentials } = props;
  const [dropdownOpen, setDropdownOpen] = useState();
  if (referentials) {
    referentials = hideTabs(referentials, 'report', source);
  }
  const listDropDown = Object.entries(referentials).map(([key]) => {
    if (!referentialToDisplay || !referentialToDisplay.includes(key)) return null;
    return (
      <DropdownItem key={key} onClick={() => setReferential(key)}>
        {t(key)}
      </DropdownItem>
    );
  });

  const toggle = () => {
    setDropdownOpen(dropdownOpen !== true);
  };

  return (
    <>
      {!isTablet && (
        <BrowserView>
          <Row>
            <Col xs="12">
              <small>
                <Translate code="cost_referential" />
              </small>
            </Col>
            <Col xs="12">
              <Dropdown className="btn-sm" isOpen={dropdownOpen} toggle={() => toggle()}>
                <DropdownToggle size="sm" caret>
                  {t(referential)}
                </DropdownToggle>
                <DropdownMenu>{listDropDown}</DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </BrowserView>
      )}
      <MobileView>
        <Row>
          <Col>
            <small>
              <Translate code="cost_referential" />
            </small>
          </Col>
          <Col>
            <div className="text-right">
              <Dropdown className="btn-sm" isOpen={dropdownOpen} toggle={() => toggle()}>
                <DropdownToggle size="sm" caret>
                  {t(referential)}
                </DropdownToggle>
                <DropdownMenu>{listDropDown}</DropdownMenu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </MobileView>
    </>
  );
});

DropdownButton.propTypes = {
  setReferential: PropTypes.func.isRequired,
  referential: PropTypes.string.isRequired,
  referentialToDisplay: PropTypes.arrayOf(PropTypes.string).isRequired,
  referentials: PropTypes.shape().isRequired,
  source: PropTypes.string.isRequired,
};
